import React, { FC, useEffect } from 'react';
import { DeviceMangeResult } from '../../api/mobilbase/models';
import * as mobilbase from '../../api/mobilbase';

interface RequestRestartProps {
    run: boolean;
    setRun: (value: boolean) => void;
    isPending: boolean;
    setIsPending: (value: boolean) => void;
    selectedLocationId: number;
    selectedDeviceId: number;
    restartType: string;
    setManageData: (data: DeviceMangeResult) => void;
  }
  
  const RequestRestart: FC<RequestRestartProps> = ({
    run,
    setRun,
    isPending,
    setIsPending,
    selectedLocationId,
    selectedDeviceId,
    restartType,
    setManageData,
  }) => {
    useEffect(() => {
      if (run) {
        const fetchData = async () => {
          try {
            setIsPending(true);
            const response = await mobilbase.postManageDevice({
              locationId: selectedLocationId,
              deviceId: selectedDeviceId,
              body: {
                name: restartType,
                imageNumber: -1,
              },
            });
  
            if (response && response.data) {
              setManageData(response.data);
            } else {
              setManageData({ msg: 'Unexpected API response structure.' });
            }
          } catch (error) {
            console.error('Error in RequestRestart:', error);
            setManageData({ msg: 'An error occurred while restarting the device.' });
          } finally {
            setIsPending(false);
            setRun(false);
          }
        };
  
        fetchData();
      }
    }, [run, selectedLocationId, selectedDeviceId, restartType, setIsPending, setRun, setManageData]);
  
    return null;
  };
  
export default RequestRestart;